export const STATUSES = {
  draft:      { label: "Brouillon",  color: "#64748B", bg: "#F1F5F9", icon: "FileEdit" },
  submitted:  { label: "Soumis",     color: "#2563EB", bg: "#EFF6FF", icon: "Send" },
  validated:  { label: "Validé",     color: "#059669", bg: "#ECFDF5", icon: "BadgeCheck" },
  rejected:   { label: "À corriger", color: "#DC2626", bg: "#FEF2F2", icon: "AlertTriangle" },
  pending:    { label: "En attente", color: "#64748B", bg: "#F1F5F9", icon: "Clock" },
};

export const STATUS_ORDER = ["draft", "submitted", "validated"];
